import React from 'react'
import './PortfolioThumbnail.css'

interface Props {
    imageName: string;
    portfolioIndex: number;
    callback: any;
}

const PortfolioThumbnail: React.FC<Props> = ({ imageName, portfolioIndex, callback }) => {
    return (
        <div className="col-xs-12 col-sm-3 py-2 p-sm-2 text-center">
            <img data-id={portfolioIndex}
                onClick={() => callback(portfolioIndex)}
                className="thumbnail-image"
                src={require(`../../../images/thumbnails/${imageName}`).default}
            />
        </div>
    )
}

export default PortfolioThumbnail
